<template>
  <q-dialog
    v-model="shown"
    :maximized="$q.screen.lt.md"
  >
    <q-card style="min-width: 50%;">
      <q-card-section class="row items-center q-mx-xs">
        <div
          class="text-h6"
        >
          {{ printTemplate && printTemplate.name }} ({{ order && order.id }})
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <!-- eslint-disable vue/no-v-html -->
      <!-- v-html produced by backend template -->
      <q-card-section class="row justify-center">
        <div
          v-if="order && order.customTemplateHtml"
          v-html="order.customTemplateHtml"
        />
      </q-card-section>
      <!-- eslint-enable vue/no-v-html -->
      <q-card-actions class="row justify-end q-ma-sm">
        <q-btn
          v-close-popup
          label="Done"
          color="primary"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>

import Order from 'src/models/order/Order'

export default {
  name: 'CustomTemplateDialog',
  props: {
    modelValue: {
      type: Boolean,
      required: false
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      shown: false,
      id: null,
      printTemplate: null,
      order: null
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
      if (this.shown) {
        this.$trackPage(this, { orderId: this.id, printTemplateId: this.printTemplate?.id })
      } else {
        this.order?.destroy()
      }
    }
  },
  methods: {
    async show (id, printTemplate) {
      this.id = id
      this.printTemplate = printTemplate
      this.order = new Order({
        options: {
          fields: ['id', 'customTemplateHtml'],
          queryName: 'orderForCustomTemplate',
          variables: {
            id: this.id,
            printTemplateId: this.printTemplate?.id
          }
        }
      })
      await this.order.fetch()
      this.shown = true
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
